import angular from 'angular';

module.exports = angular.module('market.services', [
  require('./checkout-manager'),
  require('./facebook'),
  require('./login-signup-modal'),
  require('./mls-parser'),
  require('./unprocessable-entity-modal'),
])
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/services/index.js
 **/